var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AbstractModalHeader',{attrs:{"title":"Nowa grupa pracownicza"},scopedSlots:_vm._u([{key:"close",fn:function(){return [_c('CloseIconButton',{on:{"click":_vm.emitCloseEvent}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }